<script>
    import Link from '../../utils/link.html';
    import Menu from '../../components/navigation/menu';
    import Archive from '../../components/buttons/trash';
    import Plus from '../../components/buttons/plus';
    import Loader from '../../components/ui/loader.html';
    import { onMount, afterUpdate, getContext } from "svelte";
    import { gql } from "apollo-boost";
  
    import {COORDINATOR} from '../../graphql/coordinators';
  
    import CoordinatorGeneral from './components/sections/coordinator.general';
  
  
    const client = getContext('apollo');
  
     const components = {
      'general': CoordinatorGeneral,
    }
  
    export let match = {};
    let loading = false;
    let coordinator = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      bio: '',
      avatar: ''
    };
    let error;
    $: current = components[match.params.section] || components['general'];
   
  
    const menu = [
      {id:'general', label: 'Coordinator Details', link:`/programs/view/${match.params.id}`},
    ]
  
    
  </script>
  
  {#if loading}
    <Loader />
  {/if}
  
  {#if !loading}
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-6">
        <h1>Add Coordinator</h1>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-12">
        <!--<Menu active={match.params.section || 'general'} items={menu} />-->
      </div>
    </div>
  
    <svelte:component this={current} bind:value={coordinator} id={match.params.id} />
  {/if}
  
  